
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.25","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M14.97 1.875l3.75 1.875-3.125 4.375V18.75c0 .345-.28.625-.625.625h-1.787a2.5 2.5 0 01-2.083-1.113l-1.338-2.007a2.501 2.501 0 01-.416-1.387V10"}}),_c('path',{attrs:{"d":"M18.72 3.75l.594 12.47a.625.625 0 01-.594.654l-.03.001h-3.095M12.47.625l2.5 1.25C13.867 7 11.784 9.059 9.345 10c0 0 3.125-6.25 3.125-9.375zM1.22 3.75L.626 16.22a.625.625 0 00.625.655h3.094"}}),_c('path',{attrs:{"d":"M4.97 1.875L1.22 3.75l3.125 4.375V18.75c0 .345.28.625.625.625h1.787a2.5 2.5 0 002.083-1.113l1.13-1.7"}}),_c('path',{attrs:{"d":"M9.97 8.676c-.912-2.01-2.5-5.823-2.5-8.05l-2.5 1.25c.946 4.393 2.612 6.533 4.606 7.648M7.47.625h5m-.625 12.188a.313.313 0 110 .625.313.313 0 010-.626"}})])])
          )
        }
      }
    